import {api} from '../../contexts/AuthContext';
import type {
    ReleaseMarker,
    ScheduledJobPerformance,
    ScheduledJobPerformanceByBlueprint,
    ScheduledJobPerformanceByJob,
    ScheduledJobPerformanceDay,
    ScheduledJobPerformanceMetrics,
    ScheduledJobPerformanceOutcome,
    ScheduledJobPerformanceOutcomeDay,
} from '../../types';

export type {
    ReleaseMarker,
    ScheduledJobPerformance,
    ScheduledJobPerformanceByBlueprint,
    ScheduledJobPerformanceByJob,
    ScheduledJobPerformanceDay,
    ScheduledJobPerformanceMetrics,
    ScheduledJobPerformanceOutcome,
    ScheduledJobPerformanceOutcomeDay,
};

// Job Performance admin page (deepcontext-l6wj). Backed by the daily-aggregate
// endpoint (deepcontext-hpsw) and the release-markers endpoint (deepcontext-2lfx).
export const jobPerformanceApi = {
    // `includePerJobDays` (deepcontext-qwjt) batches every job's own daily
    // series into this one response, so the caller never has to fan out a
    // separate request per job just to prefetch its breakdown.
    getPerformance: async (days: number, jobId?: string, includePerJobDays?: boolean): Promise<ScheduledJobPerformance> => {
        const params = new URLSearchParams();
        params.append('days', days.toString());
        if (jobId) params.append('jobId', jobId);
        if (includePerJobDays) params.append('includePerJobDays', '1');

        const response = await api.get(`/api/scheduled-jobs/performance?${params.toString()}`);
        return response.data;
    },

    getReleases: async (): Promise<ReleaseMarker[]> => {
        const response = await api.get('/api/scheduled-jobs/releases');
        return response.data.releases;
    },
};
